{
	"split": {
		"logoAlt": "Malaysia 34th SEA Games · 14th ASEAN Para Games 2027",
		"taglineLine1": "Raikan Perpaduan.",
		"taglineLine2": "Celebrating Unity.",
		"welcome": "Welcome to the SEA Games Malaysia 2027 Games Management System."
	},
	"login": {
		"title": "Welcome back",
		"subtitle": "Sign in to continue to your account",
		"identifier": {
			"label": "Username or email",
			"placeholder": "Enter your username or email"
		},
		"password": {
			"label": "Password",
			"placeholder": "Enter your password",
			"show": "Show password"
		},
		"rememberMe": "Remember me on this device",
		"volunteer": {
			"prompt": "Are you a volunteer?",
			"link": "Log in here"
		},
		"submit": "Sign in",
		"help": "Forgot your password? Ask an administrator to reset it."
	},
	"reasons": {
		"expired": "Your session expired. Please sign in again.",
		"revoked": "Your session was ended. Please sign in again."
	},
	"error": {
		"requestId": "Request ID"
	},
	"mfa": {
		"codePlaceholder": "000000",
		"backToSignIn": "Back to sign in",
		"verify": {
			"title": "Two-factor code",
			"subtitle": "Signing in as {{name}}. Enter the 6-digit code from your authenticator app.",
			"code": {
				"label": "Authentication code",
				"hint": "A backup code works here too."
			},
			"submit": "Verify"
		},
		"enroll": {
			"title": "Set up two-factor",
			"subtitle": "Your role requires a second factor. Scan this with Google Authenticator, 1Password, or any TOTP app.",
			"manualEntry": "Can't scan? Enter this key manually:",
			"code": {
				"label": "Code from the app"
			},
			"submit": "Confirm and sign in"
		},
		"backupCodes": {
			"title": "Save your backup codes",
			"subtitle": "Each code works once, in place of your app. This is the only time they are shown — they are stored hashed and cannot be displayed again.",
			"copyAll": "Copy all",
			"acknowledge": "I have saved these somewhere safe.",
			"continue": "Continue"
		}
	},
	"changePassword": {
		"title": "Change password",
		"titleForced": "Choose a new password",
		"subtitle": "Every other session signs out when you do this. This one stays open.",
		"subtitleForced": "You signed in with a temporary password. Choose your own password to finish signing in.",
		"currentPassword": {
			"label": "Current password",
			"wrong": "That isn't your current password."
		},
		"newPassword": {
			"label": "New password",
			"hint": "At least 8 characters.",
			"sameAsTemporary": "Choose a password different from your temporary one."
		},
		"confirmPassword": {
			"label": "Confirm new password"
		},
		"submit": "Save new password"
	},
	"noAccess": {
		"title": "You don't have access",
		"body": "Contact your administrator to get access to the Games Management System.",
		"reasonRole": "The {{role}} role doesn't include access to this system.",
		"reasonNoGroup": "Your {{role}} role needs a user group, and your account isn't in one yet.",
		"reasonGroupInactive": "Your user group “{{group}}” is inactive, so your {{role}} role has nothing to show.",
		"reasonGroupOtherRole": "Your user group “{{group}}” is for the {{groupRole}} role, not {{role}}.",
		"reasonNoRole": "Your account has no active role.",
		"switchPrompt_one": "You also have a role that can use this system.",
		"switchPrompt_other": "You also have roles that can use this system.",
		"continueAs": "Continue as {{role}}",
		"switchFailed": "Couldn't switch role"
	}
}
